import { v4 as uuidv4 } from 'uuid';
import getBrowserFingerprint from 'get-browser-fingerprint';
import store from 'store';

import { config } from './config';
import cookies from './cookies';

const generateUUIDs = async (): Promise<[string, string, string]> => {
    let storageUUID = store.get(config.user.storageUUID) || '';
    let cookieUUID = cookies.read(config.user.cookieUUID) || '';
    let browserUUID = String(await getBrowserFingerprint());

    if (!storageUUID) {
        storageUUID = uuidv4();
        store.set(config.user.storageUUID, storageUUID);
    }

    if (!cookieUUID) {
        cookieUUID = uuidv4();
        cookies.create(config.user.cookieUUID, cookieUUID, 365);
    }

    return [storageUUID, cookieUUID, browserUUID];
};

export default generateUUIDs;
